import React, { FC, useEffect, useState } from "react";
import { getI18n, useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { Category } from "../../../models/SurveyModels";
import { useEndpoints } from "../../../hooks/useEndpoints";
import { useToastAlert } from "../../../components/ToastAlert/ToastAlert";
import { DURATION_TOAST } from "../../../utils/costants";
import { IErrorsCompanies } from "../../../models/CompaniesModel";
import { RoutesRouter } from "../../../models/Routes";
import FormCreateIssue from "../../../components/Forms/FormCreateIssue/FormCreateIssue";
import { IssuePayload, PopulatedIssue } from "../../../models/IssueModels";
import { IOption } from "../../../components/Forms/FormInput/FormSelect/FormSelect";
import { compareObject } from "../../../utils/functions";

export const CreateIssue: FC = (props) => {
  const { t } = useTranslation();
  const [issue, setIssue] = useState<PopulatedIssue>();
  const [categories, setCategories] = useState<IOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const { getIssuebyId, putIssue, createIssue, getCategories } = useEndpoints();
  const { showToast } = useToastAlert();
  const [status, setStatus] = useState<0 | 200 | 400 | 500 | 201>(0);
  const navigate = useNavigate();
  const { id } = useParams();

  const onSubmit = async (data: IssuePayload) => {
    if (id) {
      const {
        id: idIssue,
        createdAt,
        enabled,
        description,
        title,
        ...compare
      } = issue || {};

      data.questions = data.questions.map(({ column, ...rest }) => rest);
      const isEqual = compareObject(compare, data);
      if (isEqual) setStatus(200);
      else {
        const response = await putIssue(id, data);
        if (response.status === 200) {
          setStatus(200);
          showToast({
            message: `${t("issue.toast.success.edit")}`,
            type: "success",
            duration: DURATION_TOAST,
          });
        }
        if (response.status === 400) {
          setStatus(400);
          const { errors } = await response.json();
          errors.map(({ value, msg, param }: IErrorsCompanies) =>
            showToast({
              message: `${msg} ${param}`,
              subMessage: value,
              type: "error",
            })
          );
        }
        if (response.status === 500) {
          setStatus(500);
          showToast({
            message: `${t("home.template.toast.error.generic")}`,
            type: "error",
          });
        }
      }
    }
  };
  const onSubmitCreate = async (data: IssuePayload) => {
    const response = await createIssue(data);
    if (response.status === 201) {
      navigate(RoutesRouter.issue);
      showToast({
        message: `${t("issue.toast.success.create")}`,
        type: "success",
        duration: DURATION_TOAST,
      });
    }
    if (response.status === 400) {
      setStatus(400);
      const { errors } = await response.json();
      errors.map(({ value, msg, param }: IErrorsCompanies) =>
        showToast({
          message: `${msg} ${param}`,
          subMessage: value,
          type: "error",
        })
      );
    }
    if (response.status === 500) {
      showToast({
        message: `${t("home.template.toast.error.generic")}`,
        type: "error",
      });
    }
  };

  useEffect(() => {
    if (id) {
      setIsLoading(true);
      getIssuebyId(id).then((resp) => {
        setIssue(resp);
        setIsLoading(false);
      });
    }
    getCategories({
      language: getI18n().language.includes("it") ? "ITALIAN" : "ENGLISH",
    }).then((resp) => {
      const options: IOption[] = resp.map((category: Category) => {
        return {
          [category.name]: category.id,
          [category.icon]: "icon",
          [category.color]: "color",
          [category.background]: "background",
        };
      });
      setCategories(options);
    });
  }, [getCategories, getIssuebyId, id, t]);
  return (
    <FormCreateIssue
      id={id}
      status={status}
      isLoading={isLoading}
      onSumbitForm={onSubmit}
      onSubmitCreate={onSubmitCreate}
      issueData={issue}
      categories={categories}
    />
  );
};
